// import React from 'react'
// import LoginComponent from '../Components/Login/LoginComponent'
// import HitechLoginComponent from '../Components/Login/HitechLoginComponent'

// function LoginPage() {
//     return (

//         <LoginComponent/>
//     )
// }

// export default LoginPage

import React from 'react';
import LoginComponent from '../Components/Login/LoginComponent';
import HitechLoginComponent from '../Components/Login/HitechLoginComponent';

function LoginPage() {
  // Get the current hostname
  const hostname = window.location.hostname;

  // Choose component based on hostname
  let ComponentToRender = LoginComponent; // default

  if (hostname === "partners.hitechlabsindia.in" ) {
    ComponentToRender = HitechLoginComponent;
  } else if (
    hostname === "partners.metropolisindia.com" ||
    hostname === "uatpartners.metropolisindia.com" 
    || hostname === "localhost"
  ) {
    ComponentToRender = LoginComponent;
  }

  return <ComponentToRender />;
}

export default LoginPage;
